import { IBundleProduct, IManhattanBundle } from "../../../entities/manhattan/bundle/types";
import SelectedPostpaidOttProduct from "../../../entities/manhattan/submit/SelectedPostpaidOttProduct";
import BundleProductService from "../../../services/BundleProductService";
import BusinessRuleFacade from "../../../rules/manhattan/BundleProductBusinessRuleFacade";
import { ProductTypes } from "../../../constants/ProductTypes";
import { ISelectedProductStb } from "../../../entities/manhattan/submit/types";

export default class BundleDataPostOttSelectedProductsFactory {

  private readonly bundle: any;
  private readonly bundleProductService: BundleProductService;

  constructor(bundle: IManhattanBundle) {
    this.bundle = bundle;
    this.bundleProductService = BundleProductService.getInstance();
  }

  public getSelectedProducts(bundle: IManhattanBundle) {
    const businessRuleFacade = BusinessRuleFacade.getInstance();
    const stb: ISelectedProductStb = {
      id: 0,
      quantity: 0,
    };

    bundle.bundleProducts.forEach((bundleProduct: IBundleProduct) => {
      businessRuleFacade.init(bundleProduct);
      if (bundleProduct.product.productLine.productLine === ProductTypes.STB) {
        stb.id = bundleProduct.product.id;
        stb.quantity = this.bundleProductService.getBundleProductMinimumDevices();
      }
    });
    return new SelectedPostpaidOttProduct(
      bundle.id,
      bundle.productLine.productLine,
      stb
    );
  }

  public create() {
    return this.getSelectedProducts(this.bundle);
  }

}
